import Vue from 'vue'
import Vuex from 'vuex'

/* eslint-disable */
import jwtDecode from 'jwt-decode'
import router from '@/router'

Vue.use(Vuex)

const nNotifyFromLocalStorage = parseInt(localStorage.getItem('nNotify')) || 0; // GERENTE
const nNotifyFromLocalStorageG = parseInt(localStorage.getItem('nNotify')) || 0; //GESTOR
export default new Vuex.Store({
  state: {
    // token: '', ORIGINAL 
    token: localStorage.getItem('token') || '',
    userDb: '',
    /* nameUser */
    userLogin:{},
    isLoading:true,
    // nNotify:0,
    nNotify: nNotifyFromLocalStorage,
    // nNotifyGestor:0,
    nNotifyGestor: nNotifyFromLocalStorageG,
  },
  mutations: {
    getUser(state,payload){
      state.token = payload;
      if (payload === '') {
        state.userDb = ''
      }else{
        state.userDb = jwtDecode(payload)
      }
    },
    updateNotifyManager(state,count){
      state.nNotify = count;
    },
    updateNotifyGestor(state,count){
      state.nNotifyGestor = count;
    }
  },
  actions: {
    saveUser({commit}, payload){
      /* ENCRIPTAR EL TOKEN AL ALMACENARLO EN LOCALSTORAGE sabado 27 mayo 2023 2:22pm */
      /* ENCRIPTAR EL TOKEN AL ALMACENARLO EN LOCALSTORAGE sabado 27 mayo 2023 2:22pm */
      /* save data localstorage */
      localStorage.setItem('token',payload);
      commit('getUser',payload);
    },
    logOut({commit}){
      commit('getUser','');
      localStorage.removeItem('token');
      /*** Eliminar nNotify y nNotifyGestor***/
      localStorage.removeItem('nNotify')
      localStorage.removeItem('nNotifyGestor')
      /*** Eliminar nNotify y nNotifyGestor***/
      router.push({name: 'login'})
    },
    readToken({commit}){
      const token = localStorage.getItem('token');
      if (token) {
        commit('getUser',token)
      }else{
        commit('getUser','');
      }
    },
    // updateNotifyManager({commit}){
    //   commit('updateNotifyManager')
    // }
  },
  getters:{
    isActive : state => !!state.token,
    getInfoUser(state){
      state.userLogin = {
        name: state.userDb.name,
        email: state.userDb.email,
        /* NECESITO EL ID PARA FILTRAR LOS CLIENTES CREADOS POR UN USUARIO */
        _id: state.userDb.id 
      }
      return state.userLogin;
    }
  },
  modules: {
  }
})
